import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toolsConfig } from '../../../../cross-team-shared/tools.config';
import { shellConnectorToken } from '../../../../team-apis/core/shell-connector';
import { ImageContentStore } from '../../state/image-content-store';

@Component({
  selector: 'h3-edit-mode-button',
  templateUrl: './edit-mode-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EditModeButtonComponent {
  selectedToolStore = inject(ImageContentStore)('selectedTool');
  toggleEditModeTooltip = 'Toggle Edit Mode';
  icon = toolsConfig.ColorSelect.icon;

  private shellConnector = inject(shellConnectorToken);

  toggleEditMode() {
    if (this.selectedToolStore.state() === 'ColorSelect') {
      return;
    }
    this.selectedToolStore.set('ColorSelect');
    this.shellConnector.trackEvent({
      id: 'select_main_tool',
      bucket: 'navigation',
      tool: 'select',
    });
  }
}
